var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgStore = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FAE8E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9888 9.48572C11.9062 9.38905 11.7827 9.33322 11.6522 9.33322H9.91311C9.76006 9.33322 9.61919 9.40989 9.54006 9.53572L6.93137 13.7024C6.8905 13.7666 6.86963 13.8407 6.86963 13.9166C6.86963 15.0649 7.84528 15.9999 9.04354 15.9999C10.2418 15.9999 11.2175 15.0649 11.2088 13.9982L12.0783 9.83155C12.1044 9.70905 12.0705 9.58239 11.9888 9.48572Z",
    fill: "#FC573B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7392 9.33322H14.261C14.021 9.33322 13.8262 9.51989 13.8262 9.74989V13.9166C13.8262 15.0649 14.8018 15.9999 16.0001 15.9999C17.1983 15.9999 18.174 15.0649 18.174 13.9166V9.74989C18.174 9.51989 17.9792 9.33322 17.7392 9.33322Z",
    fill: "#FC573B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2608 9.33322H11.6521C11.4452 9.33322 11.2669 9.47322 11.226 9.66822L10.3478 13.9166C10.3478 15.0649 11.3234 15.9999 12.5217 15.9999C13.72 15.9999 14.6956 15.0649 14.6956 13.9166V9.74989C14.6956 9.51989 14.5008 9.33322 14.2608 9.33322Z",
    fill: "#FC573B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0688 13.7024L22.4601 9.53572C22.381 9.40989 22.2401 9.33322 22.0871 9.33322H20.348C20.2175 9.33322 20.094 9.38905 20.0114 9.48572C19.9288 9.58239 19.8958 9.70905 19.921 9.83155L20.7827 13.9166C20.7827 15.0649 21.7584 15.9999 22.9566 15.9999C24.1549 15.9999 25.1306 15.0649 25.1306 13.9166C25.1306 13.8407 25.1097 13.7666 25.0688 13.7024Z",
    fill: "#FC573B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7739 9.66822C20.733 9.47322 20.5548 9.33322 20.3478 9.33322H17.7391C17.4991 9.33322 17.3043 9.51989 17.3043 9.74989V13.9166C17.3043 15.0649 18.28 15.9999 19.4782 15.9999C20.6765 15.9999 21.6521 15.0649 21.6435 13.8349L20.7739 9.66822Z",
    fill: "#FC573B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6958 17.6668H11.2175V21.0001H14.6958V17.6668Z",
    fill: "#FD907E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7827 17.6668H17.3044V22.6668H20.7827V17.6668Z",
    fill: "#FD907E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9567 16.8333C22.3062 16.8333 21.7088 16.6358 21.2158 16.3058C20.7219 16.6358 20.1245 16.8333 19.4784 16.8333H21.2175C21.4575 16.8333 21.6523 17.02 21.6523 17.25V22.6666H23.3914V16.7908C23.248 16.8108 23.1054 16.8333 22.9567 16.8333Z",
    fill: "#FC573B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 16.8334C15.3531 16.8334 14.7549 16.635 14.2609 16.3042C13.767 16.635 13.1688 16.8334 12.5218 16.8334H15.1305C15.3705 16.8334 15.5653 17.02 15.5653 17.25V21.4167C15.5653 21.6467 15.3705 21.8334 15.1305 21.8334H10.7827C10.5427 21.8334 10.3479 21.6467 10.3479 21.4167V17.25C10.3479 17.02 10.5427 16.8334 10.7827 16.8334H12.5218C11.8766 16.8334 11.2801 16.6367 10.787 16.3075C10.2931 16.635 9.69485 16.8334 9.04355 16.8334C8.89485 16.8334 8.75224 16.8109 8.60876 16.7909V22.6667H16.4349V17.25C16.4349 17.02 16.6296 16.8334 16.8696 16.8334H19.4783C18.8314 16.8334 18.2331 16.635 17.7392 16.3042C17.2453 16.635 16.647 16.8334 16.0001 16.8334Z",
    fill: "#FC573B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8261 23.5H8.17391C6.97565 23.5 6 24.435 6 25.5833C6 25.8133 6.19478 26 6.43478 26H25.5652C25.8052 26 26 25.8133 26 25.5833C26 24.435 25.0243 23.5 23.8261 23.5Z",
    fill: "#FC573B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5219 8.5V8.08333C22.5219 6.935 21.5462 6 20.348 6H11.6523C10.454 6 9.47839 6.935 9.47839 8.08333V8.5H22.5219Z",
    fill: "#FC573B"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStore, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Store.dd80f163.svg";
export { ForwardRef as ReactComponent };